import React from "react";

export function RoutingEnvelopeIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.3736 12.718L19.8796 9.663C20.5806 9.189 20.9996 8.398 20.9996 7.552V7.552C20.9996 6.142 19.8576 5 18.4486 5H5.56565C4.15665 5 3.01465 6.142 3.01465 7.551V7.551C3.01465 8.397 3.43365 9.188 4.13465 9.663L8.64065 12.718C10.6736 14.096 13.3406 14.096 15.3736 12.718V12.718Z"
        stroke="#148DFD"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 7.55103V17C3 18.657 4.343 20 6 20H18C19.657 20 21 18.657 21 17V7.55203"
        stroke="#148DFD"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CheckCircleIcon({ selected = false }) {
  const stroke = selected ? "#148DFD" : "#405261";
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 21V21C7.029 21 3 16.971 3 12V12C3 7.029 7.029 3 12 3V3C16.971 3 21 7.029 21 12V12C21 16.971 16.971 21 12 21Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 10L11 15L8 12"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
